import { FetchResult, FetchService } from './fetch-service';
import { UserData } from '../types/user/types';

/**
 * Service class for interacting with Summary Data on backend
 */
export class SummaryService {
  private fetchService: FetchService<Record<string, string>>;
  private static instance: SummaryService | null = null;

  private constructor() {
    this.fetchService = new FetchService();
  }

  public static getInstance(): SummaryService {
    if (!SummaryService.instance) {
      SummaryService.instance = new SummaryService();
    }

    return SummaryService.instance;
  }
  
  public async getRank2Frailty(data: UserData): Promise<string | null> {
    const res: FetchResult<string> = await this.fetchService.getString('summary/rank2/physical-frailty-status/get', data);
    if (res.success) {
      const data: string | null = res.data;
      if (data != null) {
        return data;
      }
    } else {
      if (res.error) {
        throw new Error(res.error);
      }
    }
    return null;
  }

  public async getRank2(data: UserData): Promise<string | null> {
    const res: FetchResult<string> = await this.fetchService.getString('summary/rank2/status-label/get', data);
    if (res.success) {
      const data: string | null = res.data;
      if (data != null) {
        return data;
      }
    } else {
      if (res.error) {
        throw new Error(res.error);
      }
    }
    return null;
  }
  
  public async getRank1(data: UserData): Promise<string | null> {
    const res: FetchResult<string> = await this.fetchService.getString('summary/rank1/status-label/get', data);
    if (res.success) {
      const data: string | null = res.data;
      if (data != null) {
        return data;
      }
    } else {
      if (res.error) {
        throw new Error(res.error);
      }
    }
    return null;
  }

  public async getAllRank2Frailty(): Promise<Record<string, string>> {
    const res: FetchResult<Record<string, string>> = await this.fetchService.get('summary/rank2/physical-frailty-status/get-all', {});
    if (res.success && res.data != null) {
      const allDatas: Record<string, string> = res.data;
      return allDatas;
    } else {
      if (res.error) {
        throw new Error(res.error);
      }
    }
    return {};
  }

  public async getAllRank2(): Promise<Record<string, string>> {
    const res: FetchResult<Record<string, string>> = await this.fetchService.get('summary/rank2/status-label/get-all', {});
    if (res.success && res.data != null) {
      const allDatas: Record<string, string> = res.data;
      return allDatas;
    } else {
      if (res.error) {
        throw new Error(res.error);
      }
    }
    return {};
  }

  public async getAllRank1(): Promise<Record<string, string>> {
    const res: FetchResult<Record<string, string>> = await this.fetchService.get('summary/rank1/status-label/get-all', {});
    if (res.success && res.data != null) {
      const allDatas: Record<string, string> = res.data;
      return allDatas;
    } else {
      if (res.error) {
        throw new Error(res.error);
      }
    }
    return {};
  }

}
